import React from 'react'
import { Box, Text } from '@chakra-ui/core'
import keys from 'constants/keys'
import useLocaleText from 'components/useLocaleText'
import { CHART_COLORS, TASK_STATUS_CONFIG } from 'utils/taskAnalytics'
import LocaleText from 'components/LocaleText'

interface StatusTagProps {
  status: number
  size?: 'small' | 'medium'
}

export const StatusTag: React.FC<StatusTagProps> = ({ status, size = 'medium' }) => {
  const isSmall = size === 'small'

  let bgColor: string
  let textColor: string
  let localeKey: string

  switch (status) {
    case keys.TASK_STATUSES.APPROVED.value:
      bgColor = CHART_COLORS.approved
      textColor = CHART_COLORS.approvedText
      localeKey = keys.TASK_STATUSES.APPROVED.localeLiteral
      break
    case keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.value:
      bgColor = TASK_STATUS_CONFIG.approvedWithReservation.bg
      textColor = TASK_STATUS_CONFIG.approvedWithReservation.text
      localeKey = keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.localeLiteral
      break
    case keys.TASK_STATUSES.DISAPPROVED.value:
      bgColor = CHART_COLORS.rejected
      textColor = CHART_COLORS.rejectedText
      localeKey = keys.TASK_STATUSES.DISAPPROVED.localeLiteral
      break
    case keys.TASK_STATUSES.DONE.value:
      bgColor = CHART_COLORS.done
      textColor = CHART_COLORS.doneText
      localeKey = keys.TASK_STATUSES.DONE.localeLiteral
      break
    case keys.TASK_STATUSES.INPROGRESS.value:
      bgColor = CHART_COLORS.inProgress
      textColor = CHART_COLORS.inProgressText
      localeKey = keys.TASK_STATUSES.INPROGRESS.localeLiteral
      break
    case keys.TASK_STATUSES.SKIPPED.value:
      bgColor = TASK_STATUS_CONFIG.skipped.bg
      textColor = TASK_STATUS_CONFIG.skipped.text
      localeKey = keys.TASK_STATUSES.SKIPPED.localeLiteral
      break
    case keys.TASK_STATUSES.REVIEWED_BY_AI.value:
      bgColor = TASK_STATUS_CONFIG.reviewedByAi.bg
      textColor = TASK_STATUS_CONFIG.reviewedByAi.text
      localeKey = keys.TASK_STATUSES.REVIEWED_BY_AI.localeLiteral
      break
    default:
      bgColor = CHART_COLORS.todo
      textColor = CHART_COLORS.todoText
      localeKey = keys.TASK_STATUSES.TODO.localeLiteral
  }

  const t_text = useLocaleText(localeKey)

  return (
    <Box
      bg={bgColor}
      color={textColor}
      border={`1px solid ${bgColor}`}
      px={isSmall ? '8px' : '12px'}
      py={isSmall ? '2px' : '4px'}
      borderRadius={isSmall ? '8px' : '12px'}
      fontSize={isSmall ? '10px' : '12px'}
      fontWeight="500"
      display="inline-flex"
      alignItems="center"
      style={{ gap: isSmall ? '4px' : '6px' }}
    >
      <Text>
        <LocaleText text={t_text} />
      </Text>
    </Box>
  )
}
